import { Component, OnInit , OnDestroy, Renderer2,ViewChild, ElementRef} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { UserService } from '../user.service';

@Component({
  selector: 'echexpayment-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotpasswordComponent implements OnInit , OnDestroy{
	busy :Subscription;
    public forgotPassword: any = {};
    public resetpasswordEmail : boolean=false;
    public validationPassword : boolean=false;
    public invalidEmail : boolean=false;
    public NamecharacterLimitReached: { [key: string]: boolean } = {};
	
	constructor(private userService: UserService, private elementRef: ElementRef, private renderer: Renderer2, private router: Router,  private toastr: ToastrService, private  route: ActivatedRoute) { }

    ngOnDestroy() {
        this.toastr.clear();
    }

	ngOnInit() {
	}

    ngAfterViewInit() {
        this.renderer.selectRootElement('#initialFocus').focus();
    }

    @ViewChild('submitButton') submitButton: ElementRef;
    moveNext(nextInput: HTMLInputElement, checkbox : number) {
        if(checkbox === 2){
            if (this.submitButton && this.submitButton.nativeElement) {
                this.submitButton.nativeElement.focus();
                this.submitButton.nativeElement.click();
            }
          } else{
            nextInput && nextInput.focus();
          }
    }

	eventHandler(){
      this.resetpasswordEmail = false;
      this.validationPassword = false;
      this.invalidEmail = false;
    }

    focusFirstInvalidControlPlus(): void {
        const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
        if (firstElementWithErrors) {
            firstElementWithErrors.focus();
        }
      }

	// Recover Password
    recoverPassword(data) {
        this.focusFirstInvalidControlPlus();   //focus field
	    if(data.valid){
			let model: any = data.value;
            this.resetpasswordEmail = false;
            this.validationPassword = false;
            this.invalidEmail = false;
            let responseData = <any>{};
            this.busy =  this.userService.recoverPassword(model).subscribe(
                response => {
                responseData = response;
                        if(responseData.message){
                            if(responseData.status === 'error'){
                                this.toastr.error(responseData.message, 'Failed!');
                            }else{
                                this.toastr.success(responseData.message, 'Success!');
                            }
                        }
                },
                error => {
                        responseData = error;
                        this.toastr.error(responseData.error.message, 'Failed!');
                }
                );
        }
    }


    //Length validate  
    NameCharacterLimit(event: any, fieldName: string, max_length:number) {
        const maxTextLength = max_length; // Maximum text length of 20 characters
        const inputChar = event.key;
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
        const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter

        if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
            return;
        }

        const inputValue = event.target.value;

        if (inputValue.length >= maxTextLength) {
            if (allowedKeys.indexOf(inputChar) === -1) {
                this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
                setTimeout(() => {
                this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
                }, 3000);
                event.preventDefault(); // Prevent entering the exceeded character
            }
        }
    }

    isNameLimitReached(fieldName: string): boolean {
        return this.NamecharacterLimitReached[fieldName];
    }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/forgotpassword/forgotpassword.component.ts